function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

function cubicBezier(P0, P1, P2, P3, t) {
  var x = (1 - t) ** 3 * P0[0] + 3 * (1 - t) ** 2 * t * P1[0] + 3 * (1 - t) * t ** 2 * P2[0] + t ** 3 * P3[0];
  var y = (1 - t) ** 3 * P0[1] + 3 * (1 - t) ** 2 * t * P1[1] + 3 * (1 - t) * t ** 2 * P2[1] + t ** 3 * P3[1];
  return [x, y];
}

function generateEyeParameters(width) {
  let height_upper = Math.random() * width / 1.5;
  let height_lower = Math.random() * width / 1.5;
  let P0_upper_randX = Math.random() * 0.4 - 0.2;
  let P3_upper_randX = Math.random() * 0.4 - 0.2;
  let P0_upper_randY = Math.random() * 0.4 - 0.2;
  let P3_upper_randY = Math.random() * 0.4 - 0.2;
  let offset_upper_left_randY = Math.random();
  let offset_upper_right_randY = Math.random();

  let eye_true_width = width * (1 + P3_upper_randX / 8 - P0_upper_randX / 8);
  let offset_upper_left_x = randomFromInterval(-eye_true_width / 10.0, eye_true_width / 2.3);
  let offset_upper_right_x = randomFromInterval(-eye_true_width / 10.0, eye_true_width / 2.3);
  let offset_upper_left_y = offset_upper_left_randY * height_upper;
  let offset_upper_right_y = offset_upper_right_randY * height_upper;
  let offset_lower_left_x = randomFromInterval(offset_upper_left_x, eye_true_width / 2.1);
  let offset_lower_right_x = randomFromInterval(offset_upper_right_x, eye_true_width / 2.1);
  let offset_lower_left_y = randomFromInterval(-offset_upper_left_y + 5, height_lower);
  let offset_lower_right_y = randomFromInterval(-offset_upper_right_y + 5, height_lower);

  let left_converge0 = Math.random();
  let right_converge0 = Math.random();
  let left_converge1 = Math.random();
  let right_converge1 = Math.random();

  return {
    height_upper,
    height_lower,
    P0_upper_randX,
    P3_upper_randX,
    P0_upper_randY,
    P3_upper_randY,
    offset_upper_left_randY,
    offset_upper_right_randY,
    eye_true_width,
    offset_upper_left_x,
    offset_upper_right_x,
    offset_upper_left_y,
    offset_upper_right_y,
    offset_lower_left_x,
    offset_lower_right_x,
    offset_lower_left_y,
    offset_lower_right_y,
    left_converge0,
    right_converge0,
    left_converge1,
    right_converge1
  };
}

export function generateEyePoints(rands, width = 30) {
  let P0_upper = [-width / 2 + rands.P0_upper_randX * width / 16, rands.P0_upper_randY * rands.height_upper / 16];
  let P3_upper = [width / 2 + rands.P3_upper_randX * width / 16, rands.P3_upper_randY * rands.height_upper / 16];
  let P0_lower = P0_upper;
  let P3_lower = P3_upper;

  let P1_upper = [P0_upper[0] + rands.offset_upper_left_x, P0_upper[1] + rands.offset_upper_left_y];
  let P2_upper = [P3_upper[0] - rands.offset_upper_right_x, P3_upper[1] + rands.offset_upper_right_y];
  let P1_lower = [P0_lower[0] + rands.offset_lower_left_x, P0_lower[1] - rands.offset_lower_left_y];
  let P2_lower = [P3_lower[0] - rands.offset_lower_right_x, P3_lower[1] - rands.offset_lower_right_y];

  let upper_eyelid_points = [];
  for (let t = 0; t < 100; t++) {
    upper_eyelid_points.push(cubicBezier(P0_upper, P1_upper, P2_upper, P3_upper, t / 100));
  }

  let lower_eyelid_points = [];
  for (let t = 0; t < 100; t++) {
    lower_eyelid_points.push(cubicBezier(P0_lower, P1_lower, P2_lower, P3_lower, t / 100));
  }

  for (let i = 0; i < 100; i++) {
    lower_eyelid_points[i][1] = -lower_eyelid_points[i][1];
    upper_eyelid_points[i][1] = -upper_eyelid_points[i][1];
  }

  let eyeCenter = [
    upper_eyelid_points[50][0] / 2.0 + lower_eyelid_points[50][0] / 2.0,
    upper_eyelid_points[50][1] / 2.0 + lower_eyelid_points[50][1] / 2.0
  ];

  for (let i = 0; i < 100; i++) {
    lower_eyelid_points[i][0] -= eyeCenter[0];
    lower_eyelid_points[i][1] -= eyeCenter[1];
    upper_eyelid_points[i][0] -= eyeCenter[0];
    upper_eyelid_points[i][1] -= eyeCenter[1];
  }

  return { upper: upper_eyelid_points, lower: lower_eyelid_points, center: [[0, 0]] };
}

export function generateBothEyes(width = 30) {
  // Add more variation between eyes
  let widthVariation = randomFromInterval(0.8, 1.2);
  let leftWidth = width * widthVariation;
  let rightWidth = width / widthVariation;

  let rands_left = generateEyeParameters(leftWidth);
  let rands_right = generateEyeParameters(rightWidth);

  // Add significant variation to right eye
  for (let key in rands_right) {
    if (typeof rands_right[key] === 'number') {
      rands_right[key] += randomFromInterval(-rands_right[key] * 0.6, rands_right[key] * 0.6);
    }
  }

  let left_eye = generateEyePoints(rands_left, leftWidth);
  let right_eye = generateEyePoints(rands_right, rightWidth);

  for (let key in left_eye) {
    if (typeof left_eye[key] === 'object') {
      for (let i = 0; i < left_eye[key].length; i++) {
        left_eye[key][i][0] = -left_eye[key][i][0];
      }
    }
  }

  return { left: left_eye, right: right_eye };
}
